import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, Menu, X } from 'lucide-react';
import neruslogo from '../../Assests/nerusgroupbg.png'

const Header = ({ onStartWizard, onDropdownItemClick }) => {
  const [activeNavDropdown, setActiveNavDropdown] = useState(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Navigate to path safely
  const navigateTo = (path, hash) => {
    if (window.location.pathname === path) {
      if (hash) {
        const element = document.getElementById(hash);
        element?.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      window.location.href = hash ? `${path}${hash}` : path;
    }
  };

  const handleItemClick = (type, serviceId, path, hash) => {
    setActiveNavDropdown(null);
    setIsMobileMenuOpen(false);

    navigateTo(path, hash);
    if (onDropdownItemClick) {
      onDropdownItemClick(type, serviceId);
    }
  };

  const handleStartWizardClick = () => {
    setActiveNavDropdown(null);
    setIsMobileMenuOpen(false);
    if (onStartWizard) {
      onStartWizard();
    } else {
      navigateTo('/', '#wizard-section');
    }
  };

  return (
    <header className="sticky top-0 z-40 w-full bg-[#010411]/85 backdrop-blur-2xl border-b border-white/5 transition-all duration-300">
      <div className="max-w-[1536px] mx-auto px-4 sm:px-6 lg:px-8 h-24 flex items-center justify-between">

        {/* Brand Logo */}
        <div
          onClick={() => navigateTo('/')}
          className="flex items-center space-x-3 cursor-pointer group select-none shrink-0"
        >
          <motion.div
            whileHover={{ rotate: 18, scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="flex items-center justify-center"
          >
            <img
              src={neruslogo}
              alt="Nerus Logo"
              className="h-10 w-auto object-contain rounded-sm"
            />
          </motion.div>
        </div>

        {/* Interactive Desktop Navigation */}
        <nav className="hidden lg:flex items-center space-x-5 xl:space-x-8 text-sm font-bold uppercase tracking-wider xl:tracking-widest">

          {/* India Services Dropdown */}
          <div
            className="relative py-4 group"
            onMouseEnter={() => setActiveNavDropdown('india-services')}
            onMouseLeave={() => setActiveNavDropdown(null)}
          >
            <button
              onClick={() => navigateTo('/mutualfunds')}
              className="flex items-center space-x-1 text-white font-extrabold text-lg drop-shadow-[0_0_8px_rgba(255,255,255,0.4)] hover:drop-shadow-[0_0_12px_rgba(255,255,255,0.6)] transition-all duration-200"
            >
              <span className="whitespace-nowrap">India Services</span>
              <ChevronDown className="w-3.5 h-3.5 transition-transform duration-200 group-hover:rotate-180" />
            </button>

            <AnimatePresence>
              {activeNavDropdown === 'india-services' && (
                <motion.div
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: 10 }}
                  className="absolute top-full left-0 w-52 bg-[#040920]/95 backdrop-blur-xl border border-white/10 rounded-2xl p-3.5 shadow-2xl space-y-2 z-50 text-[10px]"
                >
                  <button onClick={() => handleItemClick(null, 'mutualfunds', '/mutualfunds', '')} className="w-full text-left px-3 py-2 rounded-xl text-slate-300 hover:text-cyan-400 hover:bg-white/5 transition-all">Mutual Funds</button>
                  <button onClick={() => handleItemClick(null, 'pms', '/pms', '')} className="w-full text-left px-3 py-2 rounded-xl text-slate-300 hover:text-cyan-400 hover:bg-white/5 transition-all">PMS</button>
                  <button onClick={() => handleItemClick(null, 'demataccount', '/demataccount', '')} className="w-full text-left px-3 py-2 rounded-xl text-slate-300 hover:text-cyan-400 hover:bg-white/5 transition-all">Demat Account</button>
                  <button onClick={() => handleItemClick(null, 'insurance', '/insurance', '')} className="w-full text-left px-3 py-2 rounded-xl text-slate-300 hover:text-cyan-400 hover:bg-white/5 transition-all">Insurance</button>
                  <button onClick={() => handleItemClick(null, 'loans', '/loans', '')} className="w-full text-left px-3 py-2 rounded-xl text-slate-300 hover:text-cyan-400 hover:bg-white/5 transition-all">Loans</button>
                  <button onClick={() => handleItemClick(null, 'fixeddeposits', '/fixeddeposits', '')} className="w-full text-left px-3 py-2 rounded-xl text-slate-300 hover:text-cyan-400 hover:bg-white/5 transition-all">Fixed Deposits</button>
                </motion.div>
              )}
            </AnimatePresence>
          </div>

          {/* NRI Services Dropdown */}
          <div
            className="relative py-4 group"
            onMouseEnter={() => setActiveNavDropdown('nri-services')}
            onMouseLeave={() => setActiveNavDropdown(null)}
          >
            <button
              onClick={() => navigateTo('/insurance')}
              className="flex items-center space-x-1 text-white font-extrabold text-lg drop-shadow-[0_0_8px_rgba(255,255,255,0.4)] hover:drop-shadow-[0_0_12px_rgba(255,255,255,0.6)] transition-all duration-200"
            >
              <span className="whitespace-nowrap">NRI Services</span>
              <ChevronDown className="w-3.5 h-3.5 transition-transform duration-200 group-hover:rotate-180" />
            </button>
            <AnimatePresence>
              {activeNavDropdown === 'nri-services' && (
                <motion.div
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: 10 }}
                  className="absolute top-full left-0 w-52 bg-[#040920]/95 backdrop-blur-xl border border-white/10 rounded-2xl p-3.5 shadow-2xl space-y-2 z-50 text-[10px]"
                >
                  <button onClick={() => handleItemClick(null, 'mutualfunds', '/mutualfunds', '')} className="w-full text-left px-3 py-2 rounded-xl text-slate-300 hover:text-cyan-400 hover:bg-white/5 transition-all">Mutual Funds</button>
                  <button onClick={() => handleItemClick(null, 'pms', '/pms', '')} className="w-full text-left px-3 py-2 rounded-xl text-slate-300 hover:text-cyan-400 hover:bg-white/5 transition-all">PMS</button>
                  <button onClick={() => handleItemClick(null, 'demataccount', '/nri/demat', '')} className="w-full text-left px-3 py-2 rounded-xl text-slate-300 hover:text-cyan-400 hover:bg-white/5 transition-all">Demat Account</button>
                  <button onClick={() => handleItemClick(null, 'insurance', '/insurance', '')} className="w-full text-left px-3 py-2 rounded-xl text-slate-300 hover:text-cyan-400 hover:bg-white/5 transition-all">Insurance</button>
                  <button onClick={() => handleItemClick(null, 'loans', '/loans', '')} className="w-full text-left px-3 py-2 rounded-xl text-slate-300 hover:text-cyan-400 hover:bg-white/5 transition-all">Loans</button>
                </motion.div>
              )}
            </AnimatePresence>
          </div>

          {/* OCI Services Dropdown */}
          <div
            className="relative py-4 group"
            onMouseEnter={() => setActiveNavDropdown('oci-services')}
            onMouseLeave={() => setActiveNavDropdown(null)}
          >
            <button className="flex items-center space-x-1 text-white font-extrabold text-lg drop-shadow-[0_0_8px_rgba(255,255,255,0.4)] hover:drop-shadow-[0_0_12px_rgba(255,255,255,0.6)] transition-all duration-200">
              <span className="whitespace-nowrap">OCI Services</span>
              <ChevronDown className="w-3.5 h-3.5 transition-transform duration-200 group-hover:rotate-180" />
            </button>
            <AnimatePresence>
              {activeNavDropdown === 'oci-services' && (
                <motion.div
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: 10 }}
                  className="absolute top-full left-0 w-52 bg-[#040920]/95 backdrop-blur-xl border border-white/10 rounded-2xl p-3.5 shadow-2xl space-y-2 z-50 text-[10px]"
                >
                  <button onClick={() => handleItemClick(null, 'mutualfunds', '/mutualfunds', '')} className="w-full text-left px-3 py-2 rounded-xl text-slate-300 hover:text-cyan-400 hover:bg-white/5 transition-all">Mutual Funds</button>
                  <button onClick={() => handleItemClick(null, 'pms', '/pms', '')} className="w-full text-left px-3 py-2 rounded-xl text-slate-300 hover:text-cyan-400 hover:bg-white/5 transition-all">PMS</button>
                  <button onClick={() => handleItemClick(null, 'demataccount', '/oci/demat', '')} className="w-full text-left px-3 py-2 rounded-xl text-slate-300 hover:text-cyan-400 hover:bg-white/5 transition-all">Demat Account</button>
                </motion.div>
              )}
            </AnimatePresence>
          </div>

          {/* About Us Link */}
          <div className="relative py-4 group">
            <button
              onClick={() => navigateTo('/aboutus')}
              className="flex items-center space-x-1 text-white font-extrabold text-lg drop-shadow-[0_0_8px_rgba(255,255,255,0.4)] hover:drop-shadow-[0_0_12px_rgba(255,255,255,0.6)] transition-all duration-200"
            >
              <span className="whitespace-nowrap">About Us</span>
            </button>
          </div>

        </nav>

        {/* Action Call Button */}
        <div className="hidden lg:flex items-center space-x-4 shrink-0">
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={handleStartWizardClick}
            className="px-6 h-12 bg-gradient-to-r from-cyan-500 via-blue-500 to-indigo-600 text-white font-bold rounded-xl text-xs uppercase tracking-widest shadow-[0_5px_15px_rgba(14,165,233,0.3)] whitespace-nowrap"
          >
            Get started
          </motion.button>
        </div>

        {/* Hamburger Menu Icon */}
        <div className="lg:hidden flex items-center">
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="p-2.5 rounded-xl bg-white/5 border border-white/10 text-slate-300 hover:text-white transition-all active:scale-95"
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Drawer */}
      <AnimatePresence>
        {isMobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="lg:hidden bg-[#020516] border-b border-white/10 px-6 py-8 space-y-5 absolute top-full left-0 w-full shadow-2xl overflow-hidden z-50 text-xs"
          >
            <div className="space-y-2">
              <span className="font-extrabold text-[10px] text-slate-500 uppercase tracking-widest block">India Services</span>
              <div className="grid grid-cols-2 gap-2 pl-2">
                <button onClick={() => handleItemClick(null, 'mutualfunds', '/mutualfunds', '')} className="text-left text-slate-300 py-1 hover:text-cyan-400">Mutual Funds</button>
                <button onClick={() => handleItemClick(null, 'pms', '/pms', '')} className="text-left text-slate-300 py-1 hover:text-cyan-400">PMS</button>
                <button onClick={() => handleItemClick(null, 'demataccount', '/demataccount', '')} className="text-left text-slate-300 py-1 hover:text-cyan-400">Demat Account</button>
                <button onClick={() => handleItemClick(null, 'insurance', '/insurance', '')} className="text-left text-slate-300 py-1 hover:text-cyan-400">Insurance</button>
                <button onClick={() => handleItemClick(null, 'loans', '/loans', '')} className="text-left text-slate-300 py-1 hover:text-cyan-400">Loans</button>
                <button onClick={() => handleItemClick(null, 'fixeddeposits', '/fixeddeposits', '')} className="text-left text-slate-300 py-1 hover:text-cyan-400">Fixed Deposits</button>
              </div>
            </div>

            <div className="space-y-2">
              <span className="font-extrabold text-[10px] text-slate-500 uppercase tracking-widest block">NRI Services</span>
              <div className="grid grid-cols-2 gap-2 pl-2">
                <button onClick={() => handleItemClick(null, 'mutualfunds', '/mutualfunds', '')} className="text-left text-slate-300 py-1 hover:text-cyan-400">Mutual Funds</button>
                <button onClick={() => handleItemClick(null, 'pms', '/pms', '')} className="text-left text-slate-300 py-1 hover:text-cyan-400">PMS</button>
                <button onClick={() => handleItemClick(null, 'demataccount', '/nri/demat', '')} className="text-left text-slate-300 py-1 hover:text-cyan-400">Demat Account</button>
                <button onClick={() => handleItemClick(null, 'insurance', '/insurance', '')} className="text-left text-slate-300 py-1 hover:text-cyan-400">Insurance</button>
                <button onClick={() => handleItemClick(null, 'loans', '/loans', '')} className="text-left text-slate-300 py-1 hover:text-cyan-400">Loans</button>
              </div>
            </div>

            <div className="space-y-2">
              <span className="font-extrabold text-[10px] text-slate-500 uppercase tracking-widest block">OCI Services</span>
              <div className="grid grid-cols-2 gap-2 pl-2">
                <button onClick={() => handleItemClick(null, 'mutualfunds', '/mutualfunds', '')} className="text-left text-slate-300 py-1 hover:text-cyan-400">Mutual Funds</button>
                <button onClick={() => handleItemClick(null, 'pms', '/pms', '')} className="text-left text-slate-300 py-1 hover:text-cyan-400">PMS</button>
                <button onClick={() => handleItemClick(null, 'demataccount', '/oci/demat', '')} className="text-left text-slate-300 py-1 hover:text-cyan-400">Demat Account</button>
              </div>
            </div>

            <div className="space-y-2">
              <button
                onClick={() => handleItemClick(null, 'aboutus', '/aboutus', '')}
                className="font-extrabold text-[10px] text-slate-500 uppercase tracking-widest block text-left w-full hover:text-cyan-400"
              >
                About Us
              </button>
            </div>

            <button
              onClick={handleStartWizardClick}
              className="w-full mt-4 py-4 bg-gradient-to-r from-cyan-500 to-indigo-600 text-white font-extrabold rounded-xl text-xs uppercase tracking-widest shadow-lg animate-none"
            >
              Get started
            </button>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Header;
